import { useState, useEffect } from "react";

const SubFilterItem = ({
  item,
  setFiltersState,
  filterKey,
  setSelectedInstitution,
  filtersState,
  isDisplayed,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [initialised, setInitialised] = useState(false);


  useEffect(() => {
    setInitialised(true);
  }, []);


  useEffect(() => {
    if (
      Object.keys(filtersState).length &&
      filtersState[filterKey].indexOf(item.slug) > -1
    ) {
      setIsActive(true);
    }
  }, []);

  useEffect(() => {
    if (filtersState[filterKey]) {
      if (filtersState[filterKey].length <= 0) {
        setIsActive(false);
      }
    }
  }, [filtersState, isActive]);

  useEffect(() => {
    if (!isDisplayed && Object.keys(filtersState).length && initialised) {
      setFiltersState((prevState) => ({
        ...prevState,
        [filterKey]: [],
      }));
    }
  }, [isDisplayed]);



  const handleFilter = () => {
    let slugifiedName = item.slug;
    //--- Reset selected Institution on filter input
    setSelectedInstitution(null);
    // --- Add or remove the filter slug into filterState

    let newFilters = JSON.parse(JSON.stringify(filtersState));
    if (
      filtersState[filterKey].indexOf(slugifiedName) === -1 ||
      filtersState[filterKey].length === 0
    ) {
      setFiltersState((prevfilter) => ({
        ...prevfilter,
        [filterKey]: [...prevfilter[filterKey], slugifiedName],
      }));
      newFilters[filterKey].push(slugifiedName);
    } else if (newFilters[filterKey].indexOf(slugifiedName) > -1) {
      newFilters[filterKey] = newFilters[filterKey].filter(
        (elt) => elt !== slugifiedName
      );
      setFiltersState(newFilters);
    }

    setIsActive((prev) => !prev);
  };
  
  return (
    <div
      className={`subFilter-item ${isActive ? "active" : ""}`}
      onClick={handleFilter}
      style={{ display: isDisplayed ? "" : "none" }}
    >
      {item.name}
    </div>
  );
};

export default SubFilterItem;
